// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-trigger[data-v-d3cc7cc0] {\n  padding: 12px 15px;\n  border: 1px solid #e6e6e6;\n  border-radius: 2px;\n  cursor: pointer;\n  color: #494A4D;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  transition: 0.15s;\n}\n._component-trigger[data-v-d3cc7cc0]:hover {\n  border-color: #b3b3b3;\n}\n._component-trigger.active[data-v-d3cc7cc0] {\n  background: #ECBB00;\n  border-color: #ECBB00;\n  color: #17181a;\n}\n", ""]);
// Exports
module.exports = exports;
